import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { LocalCurrencyNote } from './LocalCurrencyNote';
type PricingCardProps = {
  title: string;
  featured?: boolean;
  includes: string;
  idealFor?: string;
  price: string | null;
  ctaLabel: string;
  href: string;
  image?: string;
};
export function PricingCard({
  title,
  featured = false,
  includes,
  idealFor,
  price,
  ctaLabel,
  href,
  image
}: PricingCardProps) {
  return <article className={`relative flex flex-col rounded-3xl p-7 sm:p-8 ${featured ? 'border-2 border-sun bg-raised' : 'border-2 border-brand bg-raised'}`} data-id="element-206" data-mp="2eut6pddna54p">
      {featured && <span className="absolute -top-3.5 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-sun px-4 py-1 text-xs font-black uppercase tracking-wider text-ink" data-id="element-207" data-mp="211k01kh2zxpv">
          <StarIcon className="h-3.5 w-3.5 fill-ink" aria-hidden="true" data-id="element-208" data-mp="2ssrjiecbhti3" />
          Más completo
        </span>}
      <h3 className={`text-center text-xl font-black uppercase leading-tight ${featured ? 'text-sun' : 'text-brand'}`} data-id="element-209" data-mp="32jsqfdexdfvq">{title}</h3>

      {image && <img src={image} alt="" className="mx-auto mt-5 w-full max-w-[260px]" data-id="element-210" data-mp="37ivxf3egtw6c" />}

      <dl className="mt-6 space-y-4 border-t border-line pt-6 text-left" data-id="element-211" data-mp="2stho1vaw3eqy">
        <div data-id="element-212" data-mp="2xt3y5vvf8evj">
          <dt className="text-xs font-black uppercase tracking-widest text-muted" data-id="element-213" data-mp="2xsuaiexumjt0">Incluye</dt>
          <dd className="mt-1 text-base font-bold text-white" data-id="element-214" data-mp="2jtl2i2jsqw04">{includes}</dd>
        </div>
        {idealFor && <div data-id="element-215" data-mp="2otz3x1qw77p6">
            <dt className="text-xs font-black uppercase tracking-widest text-muted" data-id="element-216" data-mp="2ouij4ap5rhzi">Ideal para</dt>
            <dd className="mt-1 text-base text-cream/90" data-id="element-217" data-mp="29x808ga6r9tr">{idealFor}</dd>
          </div>}
      </dl>

      <div className="mt-auto pt-7 text-center" data-id="element-218" data-mp="2ev013zst66a3">
        {price ? <>
            <p className="text-6xl font-black leading-none text-white" data-id="element-219" data-mp="84tknnv46hgi">{price}</p>
            <p className="mt-2 text-base font-black uppercase tracking-wide text-brand" data-id="element-220" data-mp="d2bwpn4fhcsq">6 tomos + 5 bonos incluidos</p>
            <LocalCurrencyNote className="mt-3" data-id="element-221" data-mp="bnsmw143djp4" />
          </> : <>
            <p className="text-2xl font-black text-white" data-id="element-222" data-mp="6md4yhx7ntay">Precio en tu moneda local</p>
            <p className="mt-1 text-sm text-muted" data-id="element-223" data-mp="1p3322smxp68">El importe final se muestra en el checkout según tu país.</p>
          </>}
        <div className="mt-6" data-id="element-224" data-mp="3ttnkuow9tfc4">
          <CTAButton href={href} variant={featured ? 'sun' : 'primary'} size="md" fullWidth data-id="element-225" data-mp="ucft4my08f4a">
            {ctaLabel}
          </CTAButton>
        </div>
      </div>
    </article>;
}